/** „Ha … akkor …” automatizálások – szervezetenként, szerveroldalon futnak (functions/automations.js). */

export type AutomationTriggerType =
  | 'task.status_changed'      // feladat státusza változott (opcionálisan adott kategóriára/státuszra)
  | 'task.overdue'             // feladat határideje lejárt (napi ellenőrzés)
  | 'quotation.accepted'       // árajánlat elfogadva
  | 'quotation.rejected'       // árajánlat elutasítva
  | 'lead.status_changed'      // lead státusza változott (opcionálisan adott státuszra)
  | 'form.submitted';          // űrlapot küldtek be (opcionálisan adott űrlapsablonra)

export interface AutomationTrigger {
  type: AutomationTriggerType;
  /** task.status_changed: kategória (todo/in_progress/completed/cancelled) vagy egyedi státusz-id; lead: LeadStatus. Üres = bármelyik. */
  toStatus?: string;
  /** form.submitted: űrlapsablon azonosítója. Üres = bármelyik űrlap. */
  formTemplateId?: string;
}

export type AutomationRecipient = 'creator' | 'assignee' | 'project_lead' | 'user';

export type AutomationAction =
  | { type: 'notify'; to: AutomationRecipient; userId?: string; title?: string; message?: string; email?: boolean }
  | { type: 'create_task'; title: string; description?: string; assignTo: AutomationRecipient; userId?: string; dueInDays?: number; priority?: 'low' | 'medium' | 'high' | 'urgent' }
  /** csak form.submitted: lead az űrlap adataiból (név/e-mail/telefon/cég automatikus felismeréssel; azonos e-maillel meglévő leadhez jegyzetként kerül) */
  | { type: 'create_lead'; assignTo: AutomationRecipient; userId?: string; source?: 'website' | 'manual' | 'referral' | 'social_media' | 'advertisement' | 'booking' | 'other' }
  /** csak form.submitted: visszaigazoló e-mail a kitöltőnek (az űrlap e-mail mezőjére) */
  | { type: 'email_submitter'; subject?: string; message?: string };

export interface Automation {
  id: string;
  organizationId: string;
  name: string;
  enabled: boolean;
  trigger: AutomationTrigger;
  actions: AutomationAction[];
  runCount?: number;
  lastRunAt?: any;
  createdAt?: any;
  updatedAt?: any;
  createdBy?: string;
}

export const TRIGGER_LABELS: Record<AutomationTriggerType, string> = {
  'task.status_changed': 'Feladat státusza megváltozik',
  'task.overdue': 'Feladat határideje lejárt',
  'quotation.accepted': 'Árajánlatot elfogadták',
  'quotation.rejected': 'Árajánlatot elutasították',
  'lead.status_changed': 'Lead státusza megváltozik',
  'form.submitted': 'Űrlapot küldtek be'
};

export const RECIPIENT_LABELS: Record<AutomationRecipient, string> = {
  creator: 'a létrehozó',
  assignee: 'a felelős',
  project_lead: 'a projektvezető',
  user: 'megadott személy'
};

/** Sablonváltozók, amelyeket a szerver kicserél a címben/üzenetben. */
export const TEMPLATE_VARS = ['{cím}', '{szám}', '{státusz}', '{ügyfél}', '{felelős}', '{összeg}', '{határidő}'];
/** Csak űrlap-beküldésnél elérhető változók. */
export const FORM_TEMPLATE_VARS = ['{cím}', '{ügyfél}', '{email}', '{telefon}', '{adatok}'];
